// =======================================================
// Variables
// =======================================================

// Const Global
const body  = document.body;
const home  = body.classList.contains('home');
const menu              = document.querySelector('#js-NavMain');
const menuItems         = document.querySelectorAll('#js-NavMain .menu-item-has-children.menu__item');
const menuLinks         = document.querySelectorAll('#js-NavMain .menu-item-has-children .menu__link');

// Const Simple Menu
const menuOpen          = document.querySelector('#js-OpenMenu');
const menuClose         = document.querySelector('#js-CloseMenu');
const subMenuCloses     = document.querySelectorAll('.nav-main .submenu__close');


// =======================================================
// Menu
// =======================================================

// ---------------------------------------------------
// Open/Close submenu
// ---------------------------------------------------
menuLinks.forEach(function (menuLink) {

    function OpenCloseSubmenu(menuLink) {

        // Variables
        let menuLinkParent = menuLink.parentElement;
        let menuLinkParentActive = menuLinkParent.classList.contains('js-active-submenu');

        menuItems.forEach(function (menuItem) {

            // Variables
            let menuItemActive  = menuItem.classList.contains('js-active-submenu');
            let submenuLinks    = menuItem.querySelectorAll('.submenu__link');

            // If submenu open : Remove js-active-submenu
            if (menuItemActive) {

                // Close submenu
                menuItem.classList.remove('js-active-submenu');
                body.classList.remove('js-active-navmain');

                // Check class removed
                // console.log("REMOVE menuItem ACTIVE");

                submenuLinks.forEach(function (submenuLink) {
                    submenuLink.setAttribute('tabindex', -1);
                    // console.log("tabindex-1");
                });
            }

        });

        // If submenu close : Add js-active-submenu
        if (!menuLinkParentActive) {

            // Open submenu
            menuLinkParent.classList.add('js-active-submenu');
            menu.classList.add('js-active-submenu');
            body.classList.add('js-active-navmain');

            // Check class added
            // console.log("ADD menuLinkParent ACTIVE");

            menuItems.forEach(function (menuItem) {
                let menuItemActive  = menuItem.classList.contains('js-active-submenu');
                
                if (menuItemActive) {
                    let submenuLinks    = menuItem.querySelectorAll('.submenu__link');
                    submenuLinks.forEach(function (submenuLink) {
                        submenuLink.setAttribute('tabindex', 0);
                        // console.log("tabindex-0");
                    });
                }

            });
        }

    }

    // Event click
    menuLink.addEventListener('click', (e) => {
        OpenCloseSubmenu(menuLink);

        if (home) {
            // Close Access
            let home      = document.querySelector('.front-page');
            let access    = document.querySelector('.access');
            access.classList.remove('access-js-active');
            home.classList.remove('js-active');
            // console.log("enleve les acces");
        }

        // Close Trad
        let tools             = document.querySelector('.tools');
        let translateWrapper  = tools.querySelector('.gtranslate_wrapper');
        translateWrapper.classList.remove('open');
        // console.log("enleve la trad");

        e.preventDefault();
        // console.log("e.preventdefault");
    });


    function CloseSubmenu(menuLink) {

        menuItems.forEach(function (menuItem) {

            // Variables
            let menuItemActive = menuItem.classList.contains('js-active-submenu');
            let submenuLinks    = menuItem.querySelectorAll('.submenu__link');

            // If submenu open : Remove js-active-submenu
            if (menuItemActive) {

                // Close submenu
                menuItem.classList.remove('js-active-submenu');
                body.classList.remove('js-active-navmain');

                submenuLinks.forEach(function (submenuLink) {
                    submenuLink.setAttribute('tabindex', -1);
                    // console.log("tabindex-1");
                });

                // Check class removed
                // console.log("REMOVE menuItem ACTIVE");
            }

        });
    }
    
    document.addEventListener("mouseup", function(event) {
        if (!menu.contains(event.target)) {
            CloseSubmenu(menuLink);
            // console.log("remove body class");
        }
    });

});


// ---------------------------------------------------
// Responsive menu
// ---------------------------------------------------
// Open menu
menuOpen.addEventListener('click', function () {
    menu.classList.add('js-active-menu');
    body.classList.add('js-active-responsive');
    body.classList.remove('js-active-navmain');
});

// Close menu
menuClose.addEventListener('click', function () {
    menu.classList.remove('js-active-menu');
    body.classList.remove('js-active-responsive');
    body.classList.remove('js-active-navmain');
});


// // ---------------------------------------------------
// // Responsive submenu close
// // ---------------------------------------------------
subMenuCloses.forEach(function (subMenuClose) {
    subMenuClose.addEventListener('click', function () {
        this.closest('.menu__item').classList.remove('js-active-submenu');
        body.classList.add('js-active-navmain');
        // Check deleted class
        // console.log("Remove js-active-submenu");
    });
});



// // ---------------------------------------------------
// // Responsive logo header
// // ---------------------------------------------------
let logo = document.querySelector("#js-identity");
let header = document.querySelector("#header"); 
let headerContainer = document.querySelector(".container--header");
if(window.innerWidth < 640) {
    header.insertBefore(logo, headerContainer);
    // console.log("ou est le logo");
}
